import { ColumnDef } from "@tanstack/react-table";
import type { AccountTableUser } from "@/business-settings/users/web-app-users/users-table/types";

export const SignupsCol = (): ColumnDef<AccountTableUser> => ({
  header: "Signups",
  accessorFn: (row) => row.stats?.signup_count ?? 0,
  cell: ({ getValue }) => (
    <span className="tabular-nums">{getValue() as number}</span>
  ),
  size: 100,
});
